import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-background py-12 sm:py-14 lg:py-16">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[28px] bg-gradient-to-r from-[#7c1fff] via-[#4c4cf4] to-[#25a9f5] px-6 py-14 text-center shadow-soft sm:px-10 sm:py-16 lg:px-16 lg:py-20"
        >
          {/* Background */}
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-24 left-6 h-72 w-72 rounded-full bg-background/10 blur-3xl sm:left-16 sm:h-96 sm:w-96" />
            <div className="absolute -bottom-24 right-6 h-72 w-72 rounded-full bg-background/10 blur-3xl sm:right-16 sm:h-96 sm:w-96" />
          </div>

          <div className="relative z-10 mx-auto max-w-[1000px]">
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, type: "spring" }}
              className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-background/20 sm:mb-6 sm:h-16 sm:w-16"
            >
              <Sparkles className="h-7 w-7 text-primary-foreground sm:h-8 sm:w-8" />
            </motion.div>

            <h2 className="mb-4 text-3xl font-display font-bold text-primary-foreground md:text-4xl lg:text-5xl sm:mb-6">
              Your Business Has a Problem. We Build the Right Digital{" "}
              <span className="text-white">Solution.</span>
            </h2>

            <p className="mx-auto mb-8 max-w-[860px] text-base leading-relaxed text-primary-foreground/85 sm:mb-10 sm:text-lg">
              Let’s talk about what your business actually needs to grow online.
            </p>

            <div className="flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
              <Button
                variant="premium"
                size="xl"
                asChild
                className="group w-full justify-center bg-background text-foreground hover:bg-background/90 sm:w-auto"
              >
                <Link
                  to="/contact"
                  className="flex items-center justify-center gap-2"
                >
                  Book a Free Consultation
                  <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button
                variant="glass"
                size="xl"
                asChild
                className="w-full justify-center border border-white/20 bg-white/10 text-white transition-all duration-300 hover:-translate-y-[1px] hover:bg-white/15 hover:shadow-[0_8px_30px_rgba(255,255,255,0.12)] sm:w-auto"
              >
                <Link to="/contact" className="flex items-center justify-center">
                  Contact Us
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};